<template>
  <div class="box">
    <v-row>
      <v-col cols="12">
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-data-table
          :headers="headers" :items="profileUser" item-key="uname" :height="height"
          dense hide-default-footer disable-pagination fixed-header single-select>
          <template #item.modDatim="{ value }">
            <span>{{ value | format('yyyy-MM-dd HH:mm:ss') }}</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    height: {
      type: Number,
    },
    profileUser: {
      type: Array,
    },
  },
  data() {
    return {
      headers: [
        { text: 'User', value: 'bname', sortable: false },
        { text: 'Assigned by', value: 'modbe', sortable: false },
        { text: 'Assigned at', value: 'modDatim', sortable: false },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
